(ns frontend.view.modals.delete-confirmation.sub
  (:require [frontend.view.modals.delete-confirmation.model :as model]
            [re-frame.core :as rf]))

(rf/reg-sub
 ::root
 (fn [db _]
   (get-in db model/root-path)))

(rf/reg-sub
 ::processing?
 :<-
 [::root]
 (fn [root _]
   (get-in root model/processing?-path)))

(rf/reg-sub
 ::loading?
 :<-
 [::root]
 (fn [root _]
   (get-in root model/loading?-path)))

(rf/reg-sub
 ::error
 :<-
 [::root]
 (fn [root _]
   (get-in root model/error-path)))

(rf/reg-sub
 ::confirmed?
 :<-
 [::root]
 (fn [root _]
   (get-in root model/confirmed?-path)))

(rf/reg-sub
 ::conflicts
 :<-
 [::root]
 (fn [db _]
   (get-in db model/conflicts-path)))


